export const TERMS_DOCUMENT_URL = 'https://www.scaffeye.de/agb-plattform/';
export const PRIVACY_DOCUMENT_URL = 'https://www.scaffeye.de/datenschutz-plattform/';
export const ADV_DOCUMENT_URL = 'https://www.scaffeye.de/auftragsdatenverarbeitung/';


